type PageRange = {
  start_pg: number;
  end_pg: number;
};

export type UntaggedPageDirection = "previous" | "next";

export const getUntaggedPages = (
  groups: PageRange[],
  totalPages: number,
): number[] => {
  const taggedPages = new Set<number>();
  for (const group of groups) {
    for (let page = group.start_pg; page <= group.end_pg; page++) {
      taggedPages.add(page);
    }
  }

  const untaggedPages: number[] = [];
  for (let page = 1; page <= totalPages; page++) {
    if (!taggedPages.has(page)) {
      untaggedPages.push(page);
    }
  }
  return untaggedPages;
};

export const findAdjacentUntaggedPage = (
  currentPage: number,
  direction: UntaggedPageDirection,
  untaggedPages: number[],
): number | null => {
  if (untaggedPages.length === 0) {
    return null;
  }

  // Skips the current page on purpose so repeated presses keep moving.
  if (direction === "next") {
    return untaggedPages.find((page) => page > currentPage) ?? untaggedPages[0];
  }

  for (let index = untaggedPages.length - 1; index >= 0; index--) {
    if (untaggedPages[index] < currentPage) {
      return untaggedPages[index];
    }
  }
  return untaggedPages[untaggedPages.length - 1];
};
